import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import Evidence from './pages/Evidence';
import Terminology from './pages/Terminology';
import Design from './pages/Design';
import Data from './pages/Data';
import Analysis from './pages/Analysis';
import Reporting from './pages/Reporting';
import Sharing from './pages/Sharing';
import GettingStarted from './pages/GettingStarted';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="evidence" element={<Evidence />} />
        <Route path="terminology" element={<Terminology />} />
        <Route path="design" element={<Design />} />
        <Route path="data" element={<Data />} />
        <Route path="analysis" element={<Analysis />} />
        <Route path="reporting" element={<Reporting />} />
        <Route path="sharing" element={<Sharing />} />
        <Route path="getting-started" element={<GettingStarted />} />
      </Route>
    </Routes>
  );
}

export default App;